export default {
    /* 许可批次列表生成 */
    saveVirtualsnlicenseapi: '/backstageApi/account/backstage/usercenter/snauth/saveVirtualsnlicense',
    // 分页查询数据列表
    queryVirtualsnlicensePageapi: '/backstageApi/account/backstage/usercenter/snauth/queryVirtualsnlicensePage',
    //索取所有许可信息
    queryVirtualsnlicenseAllapi: '/backstageApi/account/backstage/usercenter/snauth/queryVirtualsnlicenseAll',
    //添加信息
    saveVirtualsnbatchapi: '/backstageApi/account/backstage/usercenter/snauth/saveVirtualsnbatch',
    //查询列表
    queryVirtualsnbatchPageapi: '/backstageApi/account/backstage/usercenter/snauth/queryVirtualsnbatchPage',
    // 修改信息
    updateVirtualsnbatchpi: '/backstageApi/account/backstage/usercenter/snauth/updateVirtualsnbatch',
    // 导出批次认证
    exportmatekeyapi: '/backstageApi/account/backstage/usercenter/snauth/exportmatekey',
    // 授权反馈问题
    queryFeedbackPageapi: '/backstageApi/account/backstage/usercenter/snauth/queryFeedbackPage',
    // 问题类型
    selectFeedbackTypeListApi: '/backstageApi/account/backstage/usercenter/snauth/selectFeedbackTypeList',
    // 反馈通知配置
    getuserByEmailapi: '/backstageApi/account/backstage/usercenter/snauth/getuserByEmail',
    // 反馈通知配置修改
    userByEmailapi: '/backstageApi/account/backstage/usercenter/snauth/userByEmail',
    // 设备机器绑定关系查询
    queryPhotocontactsPageapi: '/backstageApi/account/backstage/usercenter/contacts/queryPhotocontactsPage',
    // 生成 设备授权配置项
    queryDeviceAuthConfig: '/backstageApi/account/backstage/usercenter/snauth/deviceAuthConfig',
    // 新增授权许可关联人
    userBindSnLicenseInsert: '/backstageApi/account/backstage/sysUserBindVirtualSn/insert',
    // 用户门铃、monitor设备绑定关系查询
    queryCameraListPage: '/backstageApi/account/backstage/usercenter/contacts/queryCameraListPage',
    // 门铃设备p2p日志
    queryP2pByDeviceListPage: '/backstageApi/account/backstage/usercenter/apk/queryP2pByDeviceListPage',

}



// WEBPACK FOOTER //
// ./src/api/device/auth.js